import { useEffect, useState } from 'react';
import './StudentObservation.scss'
import Button from '../../../button/button';
import { PatchUpdateObservationByStudent } from '../../../../utils/Apis/receptionApis';
import { useRef } from 'react';
const StudentObservation = ({observation,student_id, showAlert}) => {
    const [observationState, setObservationState] = useState('');
    const [disableObservationButton, setDisableObservationButton] = useState(false)

    const cacheStudentObservation = useRef({})
    useEffect(()=>{
        if (observation !== null || observation !== undefined) {
            if (student_id in cacheStudentObservation.current) {
                setObservationState(cacheStudentObservation.current[student_id])
            }else{
                setObservationState(observation)
            }

            
        }
    },[observation])

    const handleSaveObservation = async () => {
        setDisableObservationButton(true)
        const updateObservation = await PatchUpdateObservationByStudent(student_id, observationState)
        if (updateObservation.status === 200) {
            showAlert('success', updateObservation.message);
            setTimeout(() => {
                setDisableObservationButton(false)
            }, 2000);
            cacheStudentObservation.current[student_id] = observationState
        } else {
            showAlert('danger', updateObservation.message);
            setDisableObservationButton(false)
        }
    }
    return (

        <div className='student-observation-container'>
            <h1 className='title-2'>Observaciones</h1>
            <textarea className='text-area-observation'
                value={observationState}
                onChange={(e) => setObservationState(e.target.value)}
            />
            <Button
                text='Guardar cambios'
                onClick={handleSaveObservation}
                disabled={disableObservationButton}
            />
        </div>

    )
}
export default StudentObservation;